export default "/images/vendor/flag-icon-css/flags/4x3/ne.svg?6fd3ccdef1a91e8be5aef3841765069d";